import { useAccountHookFactory } from '@genoa/state-management'

import { useAuthState } from '../contexts'
import { useGetAccountQuery } from '../modules/flexApi'

export function useAccount() {
  return useAccountHookFactory(useGetAccountQuery, useAuthState)
}
